import React, { useState } from 'react';
import { AdminToolTabs } from '../TabNavigation/AdminToolTabs';
import { AdminToolTabPanels } from '../TabNavigation/AdminToolTabPanels';
import { EmailVerificationTable } from '../AdminTools/EmailVerificationTable';
import { ManageRosters } from '../AdminTools/ManageRosters.tsx';
import { ManageUsers } from '../AdminTools/ManageUsers.jsx';

export function AdminToolsDashboard(props) {
    const { alert } = props;
    const [tabValue, setTabValue] = useState(0);
  
    const handleChange = (event, tab) => {
        event.preventDefault();
        setTabValue(tab);
    };

    return (
        <div id="admin-tools-dashboard">
            <AdminToolTabs value={tabValue} handleChange={handleChange}>
                <AdminToolTabPanels value={tabValue} index={0}>
                    <ManageRosters alert={alert} />
                </AdminToolTabPanels>
                <AdminToolTabPanels value={tabValue} index={1}>
                    <EmailVerificationTable alert={alert} />
                </AdminToolTabPanels>
                <AdminToolTabPanels value={tabValue} index={2}>
                    <ManageUsers alert={alert} />
                </AdminToolTabPanels>
            </AdminToolTabs>
        </div>
    )
}
